import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var modalMenu = createMultiStyleConfigHelpers(["dialog", "closeButton", "header", "body", "footer"]);
var ModalMenu = modalMenu.defineMultiStyleConfig({
    baseStyle: {
        breakpoints: {
            sm: "320px",
            md: "768px",
            lg: "960px",
            xl: "1200px",
        },
        dialog: {
            borderRadius: 'lg',
            "@media only screen and (max-width: 768px)": {
                borderRadius: '16px 16px 0 0',
            },
        },
        header: {
            fontSize: '20px',
            fontWeight: '500',
            p: '24px 0 24px 24px',
        },
        closeButton: {
            width: "24px",
            height: '24px',
            bg: 'neutrals.200',
            position: 'absolute',
            top: '28px',
            right: '24px'
        },
        body: {
            height: '96px',
            fontSize: '16px',
            fontWeight: '400',
            p: '0',
            mx: '5',
            my: '3'
        },
        footer: {
            height: '92px',
            p: '24px 24px 24px 0',
            "@media only screen and (max-width: 768px)": {
                height: '108px',
                ".chakra-button": {
                    width: '160px !important',
                    height: '44px !important'
                }
            },
            ".chakra-button": {
                py: '3',
                width: 'max-content',
                minWidth: '95px',
                borderRadius: 'md'
            }
        },
    }
});
var modalTheme = ModalMenu;

export { modalTheme };
//# sourceMappingURL=modal.js.map
